<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="orderNo"
      :col='4'
      :itemNames="['search_orderNo','search_name','search_status','create_button',]"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_orderNo" label="订单号" v-bind="formItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入抢购订单号"></a-input>
      </a-form-item>
      <a-form-item slot="search_name" label="店铺名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.storeName" placeholder="请输入店铺名称"></a-input>
      </a-form-item>
      <a-form-item slot="search_status" label="订单类型" v-bind="formItemLayout">
        <a-select v-model="queryParams.dyOrderType" placeholder="请选择" allowClear style="width:100%;">
          <a-select-option v-for="item in goodsTypeList" :value="item.key" :key="item.key">{{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="onSearch">查 询</a-button>
      </a-form-item>
      <template slot="personSlots" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.contactPhone }}</div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
import TiktokMixins from '@/views/service/serviceProvider/tiktokHelper/mixins/TiktokMixins'

export default {
  name: 'TiktokOrderList',
  mixins: [TiktokMixins],
  components: {},
  data() {
    return {
      popupVisible: false,
      submitLoading: false,
      queryParams: {
        dyOrderType: undefined,
        orderNo: '',
        storeName: ''
      },
      loadPromise: params => this.getListPromise(params),
      goodsTypeList: []
    }
  },
  mounted() {
    this.getGoodsType()
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
    },
    handleCancel() {
      this.popupVisible = false
    },
    getGoodsType() {
      this.getHttpServices().getProService().post('api/douyin/helper/goods/typeGet').then(res => {
        this.getLogUtils().logWithTag('getGoodsType', res)
        this.goodsTypeList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getApiService().post('api/dy/order/getDyOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '抖音订单号',
          dataIndex: 'dyOrderNo'
        },
        {
          title: '抢购订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '预约订单号',
          dataIndex: 'reservationOrderNo'
        },
        {
          title: '店铺名称',
          dataIndex: 'storeName'
        },
        {
          title: '产品名称',
          dataIndex: 'proName'
        },
        {
          title: '订单类型',
          dataIndex: 'dyOrderTypeStr'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'personSlots' }
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">

</style>